import { useState } from 'react';
import { hasUnsavedWork } from '@/stores/workDrafts';
import { Button, Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/v2/design-system/primitives';

/** Only deliberate account changes ask; expiry/401 must always clear the session. */
export function useConfirmDiscardWork() {
  const [pending, setPending] = useState<(() => void) | null>(null);
  const run = (action: () => void) => {
    if (hasUnsavedWork()) setPending(() => action);
    else action();
  };
  const confirmation = (
    <Dialog open={Boolean(pending)} onOpenChange={(open) => { if (!open) setPending(null); }}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Há alterações não salvas</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <DialogDescription>Salve o registro do atendimento ou envie as mensagens antes de sair ou trocar de empresa. Se continuar agora, os rascunhos serão descartados.</DialogDescription>
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={() => setPending(null)}>Voltar e continuar</Button>
          <Button variant="danger" onClick={() => { const action = pending; setPending(null); action?.(); }}>Descartar e continuar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
  return { run, confirmation };
}
